import { applyDiscount } from 'legacy/events/helpers';
import { DiscountCodeDto, EventForUser } from 'legacy/events/types';
import { trackTransaction } from 'legacy/common/utils/ga';
import { OutgoingCheckoutSessionDto } from 'api/dtos/events/checkout';
import { EventProductMappedToTier } from 'legacy/common/types/models';
import { MultiTierCheckoutSession } from '../../types';

/**
 * Logs a transaction to Google Analytics.
 */
const logTransactionToGA = (
  checkoutSession: MultiTierCheckoutSession | OutgoingCheckoutSessionDto,
  event: EventForUser,
  discountData: DiscountCodeDto,
  tiers: EventProductMappedToTier[]
) => {
  const items = Object.keys(checkoutSession?.ticketBasket || {}).map(
    (ticketId) => {
      const selectedTier = tiers.find((tier) => tier._id === ticketId);

      return {
        id: ticketId,
        name: `${event?._id}-${selectedTier.name}`,
        quantity: checkoutSession.ticketBasket[ticketId],
        price: applyDiscount(selectedTier.price, discountData)?.toFixed(2)
      };
    }
  );

  trackTransaction({
    id: checkoutSession.paymentIntentId,
    affiliation: 'Bounce Web',
    currency: checkoutSession.currency,
    tax: checkoutSession.pricing.taxes.toFixed(2),
    value: checkoutSession.total.toFixed(2),
    items
  });
};

export default logTransactionToGA;
